import { BaseModel } from "@/models/base.model"
import { type IRentalIntakeItem } from "@/interfaces/api/rental-intake-item.interface"
import type { Units } from "@/enums/units.enum"
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import { unitToName } from "@/helper/enums/unit-helper"
import { ModelFactory } from "@/factories/model-factory"
import { normalizeDecimal } from "@/helper/number-helper.ts"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"

export class RentalIntakeItem extends BaseModel implements IRentalIntakeItem {
  public static className = "RentalIntakeItem" // Used for socket communication.
  public static verboseName = "Inhuurartikel"

  public static override managedResolveFields = ["supplier", "rentalDispenseItem"]

  id: string

  rentalDispenseItem: RentalDispenseItem

  supplier: KnownBusinessEntity

  name: string

  unit: Units

  unitPricePerDay: string | undefined

  constructor(rentalIntakeItem: IRentalIntakeItem, managed = false) {
    super(rentalIntakeItem)

    this.id = rentalIntakeItem.id
    this.rentalDispenseItem = ModelFactory.childModel(
      RentalDispenseItem,
      rentalIntakeItem.rentalDispenseItem,
      managed
    )
    this.supplier = ModelFactory.childModel(KnownBusinessEntity, rentalIntakeItem.supplier, managed)

    this.name = rentalIntakeItem.name
    this.unit = rentalIntakeItem.unit
    this.unitPricePerDay = rentalIntakeItem.unitPricePerDay
  }

  public getDisplayText() {
    return `
      Inhuur ${this.name} ${this.supplier.name} ${this.getUnitName()}
      ${this.unitPricePerDay ? normalizeDecimal(this.unitPricePerDay) : "???"}
     `
  }

  public getUnitName() {
    return unitToName(this.unit)
  }
}
